var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVP01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.upper1{fill:#d0e0f4;}\t.lower1{fill:#66a3b6;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "upper1",
    d: "M162.21,868.63l133.42-145.6C172.45,610.16,164.1,418.8,276.97,295.63      C389.84,172.45,581.2,164.1,704.37,276.97l133.42-145.6C634.2-55.2,317.92-41.39,131.36,162.21      C-55.19,365.8-41.39,682.08,162.21,868.63z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "lower1",
    d: "M837.79,131.37l-133.42,145.6c123.18,112.87,131.53,304.23,18.66,427.4    C610.16,827.55,418.8,835.9,295.63,723.03l-133.42,145.6c203.59,186.56,519.87,172.75,706.43-30.84    C1055.19,634.2,1041.39,317.92,837.79,131.37z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVP01);
export default __webpack_public_path__ + "static/media/vP_01.443ab3270478953c38191bc6d562556e.svg";
export { ForwardRef as ReactComponent };